<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#accounts"
                               @click="gotoTab(1)">
                                {{ $t('deposit.accounts') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#verified_companies"
                               @click="gotoTab(2)">
                                {{ $t('deposit.verified_companies') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#accounts">
                        <div style="margin-top: 15px" id="accounts"
                             aria-labelledby="accounts"
                             data-parent="#accounts">
                            <accounts></accounts>
                        </div>
                    </div>
                    <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" id="#verified_companies">
                        <div style="margin-top: 15px" id="verified_companies"
                             aria-labelledby="verified_companies"
                             data-parent="#verified_companies">
                            <verified-companies></verified-companies>
                        </div>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import accounts from './accounts.vue'
import verifiedCompanies from './verified-companies.vue'
import MainContent from "@/components/main-content.vue";

export default {

    components: {
        MainContent,
        accounts,
        'verified-companies':verifiedCompanies
    },
    data() {
        return {
            query: {},
            currentTab: 1
        }
    },
    computed: {},
    methods: {
        gotoTab(index) {
            this.currentTab = index;
        }
    },
    mounted() {
        if (this.$route.fullPath.includes('#verified_companies'))
            this.gotoTab(2)
    }
}
</script>

<style>

</style>